import React from "react"
import { Button, Grid } from "@material-ui/core"
import { Alert } from "@material-ui/lab"
import AceEditor from "react-ace"

import { Loading, Portlet } from "@/components"
import ImportContactsSkeleton from "@/skeletons/Admin/ImportContactsSkeleton"

interface ImportContactsByTextProps {
	loading: boolean
	isContactsToImportBeingProcessed: boolean
	totalContactsProcessed: number
	whatsappNumbersToImport: string
	handleChangeWhatsappNumbersToImport: (value: string) => void
	handleContactsImportByText: () => void
	ContactsBeingProcessedScreen: React.ComponentType<{ totalContactsProcessed: number }>
}

const ImportContactsByText = ({
	loading,
	isContactsToImportBeingProcessed,
	totalContactsProcessed,
	whatsappNumbersToImport,
	handleChangeWhatsappNumbersToImport,
	handleContactsImportByText,
	ContactsBeingProcessedScreen
}: ImportContactsByTextProps) => {
	return (
		<Grid container>
			<Loading loading={loading} customLoadingElement={<ImportContactsSkeleton />}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Portlet>
							{
								isContactsToImportBeingProcessed &&
								<ContactsBeingProcessedScreen
									totalContactsProcessed={totalContactsProcessed}
								/>
							}
							{ !isContactsToImportBeingProcessed && <Grid container direction="column" spacing={3}>
								<Grid item xs={12}>
									<Alert icon={false} severity="warning">
										Cole no campo abaixo os números que deseja importar, sendo <b>um contato por linha.</b> Os números devem ser enviados com DDI, DDD e 9° dígito. Ex.: <b>55 11 9 94544758</b> (desconsideramos qualquer caractere que não seja número) <br /><br />
										<b>IMPORTANTE:</b> A importação por texto permite que você importe contatos inserindo <b>apenas os números de telefone</b>, mas lembre-se que eles serão cadastrados <b>sem um nome.</b><br /><br />
										Nesse caso, <b>os números inseridos serão cadastrados como o nome dos contatos.</b> Recomendamos a <b>importação por arquivo</b> para uma melhor identificação dos seus contatos.<br />
									</Alert>
								</Grid>

								<Grid item>
									<Grid container alignItems="stretch">
										<Grid item xs={12} style={{ display: "flex" }}>
											<AceEditor
												mode="text"
												theme="github"
												width="100%"
												height="17.75rem"
												value={whatsappNumbersToImport}
												onChange={handleChangeWhatsappNumbersToImport}
												showPrintMargin={false}
											/>

										</Grid>
									</Grid>
								</Grid>

								<Grid item>
									<Grid container justifyContent="flex-end">
										<Grid item>
											<Button
												color="primary"
												variant="contained"
												onClick={handleContactsImportByText}
											>
												IMPORTAR
											</Button>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
							}
						</Portlet>
					</Grid>
				</Grid>
			</Loading>
		</Grid>
	)
}

export default ImportContactsByText
